<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-button type="default" icon="el-icon-download" @click="exportList()">导出</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form :inline="true" :model="formQuery" size="mini" class="smui-form-right">
                <el-form-item label="单号">
                  <el-input v-model="formQuery.order_no" placeholder="ICCID号" clearable></el-input>
                </el-form-item>
                <el-form-item label="ICCID号">
                  <el-input v-model="formQuery.iccid" placeholder="ICCID号" clearable></el-input>
                </el-form-item>
                <el-form-item label="下单时间">
                <el-date-picker
                    v-model="order_time"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    style="width: 220px;">
                </el-date-picker>
            </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="search()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          
          <div class="sanmuui-body-container">
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                @selection-change="handleSelectionChange"
                size="small"
                border
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="order_no"
                  label="单号"
                  width="220">
                </el-table-column>
                <el-table-column
                  prop="merchant_pkg_name"
                  label="套餐名称"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="cycle_month"
                  label="周期(月)"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="amount"
                  label="订单金额"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="pay_time"
                  label="付款时间"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="user_name"
                  label="付款人"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="pay_method"
                  label="支付方式"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="pay_trade_no"
                  label="交易单号"
                  width="220">
                </el-table-column>
                <el-table-column
                  prop="operator"
                  fixed="right"
                  label="更多"
                  width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="displayDetail(scope.row.order_id)">详情</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>
          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>
      </el-col>
    </el-row>

    <el-drawer
        title="订单详情"
        :visible.sync="drawer"
        :with-header="false"
        :direction="direction">
        <div class="dr-container">
          <el-table
              :data="renewalsCardListTable"
              border
              style="width: 100%">
              <el-table-column
                  prop="iccid"
                  label="ICCID"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="sim"
                  label="SIM"
                  width="150">
              </el-table-column>
              <el-table-column
                  prop="ex_expired"
                  label="续费前到期"
                  width="150">
              </el-table-column>
              <el-table-column
                  prop="now_expired"
                  label="当前到期"
                  width="150">
              </el-table-column>
          </el-table>
        </div>
    </el-drawer>

  </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'renewals_order',
  data() {
    return {
      order_time: null,
      formQuery: {
        order_no: '',
        iccid: '',
        start_time: null,
        end_time: null,
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      displayPassword: false,
      formLabelWidth: "110px",
      formNew: {
        iccids: "",
        payload: ""
      },
      rules: {
        iccids: [
          { required: true, message: '请输入ICCID号', trigger: 'blur' }
        ],
        payload: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      tableViewHeight: 600,
      multipleSelection: [],
      loadingTableData: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      drawer: false,
      direction: 'rtl',  // Drawer 抽屉: 从右往左开
      drActiveName: 'detail',
      renewalsCardListTable: [],
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.pagging.current_page = val;
      this.search();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 将字符串以逗号或换行符分割成数组
     * @param {string} str - 要分割的字符串
     * @returns {Array} 分割后的数组
     */
    splitByCommaOrNewline: function(str) {
      // 使用正则表达式匹配逗号或换行符（包括Windows和Unix风格的换行符）
      return str.split(/[,|\r\n|\n|\r]+/)
        // 过滤掉空字符串
        .filter(item => item.trim() !== '');
    },
    search: function() {
      this.loadingTableData = true;
      this.tableData = [];

      if(this.order_time) {
        this.formQuery.start_time = this.order_time[0];
        this.formQuery.end_time = this.order_time[1];
      }
      this.formQuery.page_index = this.pagging.current_page;
      this.formQuery.page_size = this.pagging.pager_size;
      Api.RenewalsOrderList(this.formQuery).then(res => {
        this.loadingTableData = false;
        if(res && res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          this.tableData = res.data;
        } else {
          // this.$message.error(err);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    exportList: function() {
      if(this.order_time) {
        this.formQuery.start_time = this.order_time[0];
        this.formQuery.end_time = this.order_time[1];
      }
      Api.ExportOrderList(this.formQuery).then(res => {
          if(!res)
            return;
          if(res.code != 200) {
            this.$message.error(res.msg);
          }
          if(res.data) {
            var hostStr = window.location.host;
            var my_request = hostStr.indexOf('sanmuiot.com') > -1 ?
                `https://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}` :
                `http://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}`;
            window.open(my_request);
          } else {
            this.$message.error('无数据导出！');
          }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    displayDetail: function(order_id) {
      // 订单详情
      this.drawer = true;
      Api.RenewalsOrderSimDetail({ order_id: order_id }).then(res => {
        if(res && res.code === 200 && res.data) {
          this.renewalsCardListTable = res.data;
        } else {

        }
      });
    },
  },
  mounted() {
    var h = document.body.clientHeight - 60 - 130;
    var h2 = document.body.clientHeight - 115;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.search();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.smui-form-right {
  float: right;
}
</style>